import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa-check-circle",
  "use": "icon-fa-check-circle-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-fa-check-circle\">\r\n<path d=\"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm113.3-301.3L237.4 342.6c-9.7 9.7-25.5 9.7-35.2 0l-64-64c-9.7-9.7-9.7-25.5 0-35.2s25.5-9.7 35.2 0l46.4 46.4 131.7-131.7c9.7-9.7 25.5-9.7 35.2 0s9.7 25.5 0 35.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa-check-circle.svg
// module id = CJ45
// module chunks = 36